//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngUserProfileMyGrants', srsngUserProfileMyGrants);

    function srsngUserProfileMyGrants(userService, userGroupService) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/user-profile/my-grants/user-profile-my-grants.html',
            scope: {
                errorCallback: '='
             },
            controller: controller
        };

        function controller($scope, $rootScope, $q, $timeout, excelExportService, utilService) {

            var tableData = {
                grants: [],
                unfilteredGrants: []
            };
            var removedItems = [];


            var tableModelDefinitions = {
                displayFilter: false,
                filterAvailable: true,
                columns: [
                    {
                        key: "name",
                        order: 0,
                        title: "{{'container.userprofile.groupName' | translate}}",
                        width: 50,
                        minWidth: 50,
                        removable: false,
                        columnGroupIndex: 0,
                        visible: true,
                        dataType: 'text'
                    },
                    {
                        key: "description",
                        order: 1,
                        title: "{{'container.userprofile.groupDescription' | translate}}",
                        width: 50,
                        minWidth: 50,
                        removable: false,
                        columnGroupIndex: 0,
                        visible: true,
                        dataType: 'text'
                    }                    
                ],
                columnGroups: [{
                    scrollable: true
                }]
            };
            
            $scope.megaTableOptions = {
                data: tableData.grants,
                tableId: 'my-grants-table',
                initialize: function (mt) {
                    $scope.megatable = mt;
                },
                showFooter: false,
                showHeader: true,
                showSelectColumn: false,
                multiSelect: false,
                showActionForSelectedItems: false,
                showActionColumn: false,
                tableActionMenu: [
                    { label: "container.megaTable.exportXlsx", callback: exportXlsx }
                ],
                itemsFiltered: filteredItems => {
                    tableData.grants = filteredItems;
                },
                dataSource: {
                    rowCount: function () {
                        return tableData.grants && tableData.grants.length || 0;
                    },
                    cellContent: function (columnKey, rowIndex) {

                        var entity = tableData.grants[rowIndex];
                        if (!entity) {
                            return;
                        }

                        return $('<div>' + utilService.setEmptyIfNull(entity[columnKey]) + '</div>'); //TODO adminConverterService.setEmptyIfNull(entity[columnKey])
                    },
                    itemAt: function (rowIndex) {
                        return tableData.grants && tableData.grants[rowIndex];
                    },
                    items: function () {
                        return tableData.grants;
                    },
                    unfilteredItems: function () {
                        return tableData.unfilteredGrants;
                    }
                },
                model: tableModelDefinitions
            };

            

            activate();

            function activate() {
                let promise = userService.getAssignedUserGroups()
                    .then(response => {
                        console.log("response: ", response);
                        tableData.grants = response.slice();
                        tableData.unfilteredGrants = tableData.grants.slice();
                        tableData.initialItems = tableData.grants.slice();
                        $timeout(() => {
                            $scope.megatable.updateData();
                        });
                    }, (error) => {
                        $rootScope.$emit('displayError', "container.notification.displayError", error);
                    });                    
                $rootScope.$emit('handleBusyPromise', promise);
            }

            function detachGrant(rowIndex) {
                removedItems.push(tableData.grants.splice(rowIndex, 1));
                $scope.megatable.updateData();
            }

            function exportXlsx() {
                var data = [];
                if (tableData.grants !== undefined && tableData.grants.length > 0) {data = tableData.grants;}
                else {data = tableData.unfilteredGrants;}
                excelExportService.generateExcel(data, $scope.megatable.getColumnOrder());
            }

            $rootScope.$on('userProfile:save', save);
            function save() {
                if (removedItems.length == 0) {
                    return;
                }
                var errors = [];
                var promises = [];
                for (var i=0;i<removedItems.length;i++) {
                    var dto = {
                        groupId: removedItems[i][0].id,
                        groupVersion: removedItems[i][0].version
                    }
                    console.log("removing grant for: ", dto.groupId, " v", dto.groupVersion);
                    
                    let promise = userGroupService.removeUserFromGroup(dto)
                    .catch(err => {
                        console.log("removeUserFromGroup err: ", err);
                        errors.push(err);
                        return;
                    });
                    promises.push(promise);
                }
                          
                $rootScope.$emit('handleBusyPromise', $q.all(promises).then(() => {
                    if (errors.length > 0) {
                        console.log("errors occurred: ", errors);
                        $scope.errorCallback(errors);
                    }
                }))
            }

        }

    }

})();

